import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { IItemConfigSet } from "../interfaces/iconfigurationset";
import { BaseService } from "./base.service";
import { AuthService } from "./auth.service";
import { IAuditHistory } from "../interfaces/iaudithistory";
import { IPublicationHistory } from "../interfaces/ipublicationhistory";
import { ApplicationSettingsService } from "./applicationsettings.service";

@Injectable()
export class AuditHistoryService extends BaseService {
    constructor(http: HttpClient, toastr: ToastrService, authService: AuthService, private applicationSettings: ApplicationSettingsService) {
        super(http, authService, toastr);
    }

    /**
     * Get AuditHistory by ItemconfigId and Country
     * @param itemConfigId
     * @param countryCode
     */
    getHistory(itemConfigId: number, countryCode: string): Observable<IAuditHistory[]> {
        return super.get(`${this.applicationSettings.apiUrl}AuditHistory/${itemConfigId}/${countryCode}`);
    }

    /**
     * Gets list of publications based on supplied country code, returns an IItemConfigSet object
     * @param countryCode
     */
    getCountryHistoryList(countryCode: String): Observable<IItemConfigSet[]> {
        return super.get(`${this.applicationSettings.apiUrl}CountryHistory/${countryCode}`);
    }

    getPublication(countryCode: string, countryDataId: string): Observable<IPublicationHistory[]> {
        return super.get(`${this.applicationSettings.apiUrl}CountryHistory/${countryCode}/${countryDataId}`);
    }
}
